import React, { useEffect, useState } from "react";
import logo from "../../assets/images/logo-vektorski-1.png";
import "./LoginForm.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import DynamicModal from "../../components/Modal/DynamicModal";

function LoginForm({ onLogin, isOpen, onClose }) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(false);
    const [shake, setShake] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setError(false);
            setShake(false);
            setUsername("");
            setPassword("");
            setShowPassword(false);
        }
    }, [isOpen]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const success = await onLogin(username, password);

        if (!success) {
            setError(true);
            setShake(true);
            setTimeout(() => setShake(false), 500);
        }
    };

    return (
        <DynamicModal
            isOpen={isOpen}
            onRequestClose={onClose}
            customWidth="420px"
            customHeight="auto"
            customZIndex={10000}
            centered={false}
            hideHeader={true}
            contentPadding="0"
            bodyOverflowY="hidden"
            overlayBackground="transparent"
            mainContent={
                <div className="login-card">
                    <div className="login-glow" />

                    <div className="login-logo-container">
                        <img src={logo} alt="Logo" className="login-logo" />
                    </div>

                    <form onSubmit={handleSubmit} className="login-form">
                        <h2>Prijavite se</h2>

                        <div className="floating-field">
                            <input
                                type="text"
                                id="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                autoComplete="username"
                                placeholder=" "
                                className={`${error ? "input-error" : ""} ${shake ? "shake" : ""}`}
                            />

                            <label htmlFor="username">
                                Korisničko ime
                            </label>
                        </div>

                        <div className="floating-field password-field">
                            <input
                                type={showPassword ? "text" : "password"}
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                autoComplete="current-password"
                                placeholder=" "
                                className={`${error ? "input-error" : ""} ${shake ? "shake" : ""}`}
                            />

                            <label htmlFor="password">
                                Šifra
                            </label>

                            <button
                                type="button"
                                className="password-toggle-icon"
                                onClick={() => setShowPassword(prev => !prev)}
                                aria-label={showPassword ? "Sakrij šifru" : "Prikaži šifru"}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>

                        <button type="submit" className="login-submit-btn">
                            Prijava
                        </button>
                    </form>
                </div>
            }
            footerContent={null}
        />
    );
}

export default LoginForm;